import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { ComponentType } from "../../../constants";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";
import { INFINITE_PAGINATED_DATA_UPDATERS } from "../../../utils/optimisticUpdate";
import { COMPONENT_TEMPLATES_LIST_QUERY_KEY } from "../ComponentTemplateDialog";
import {
  ComponentTemplateDto,
  IAddComponentTemplateCommand,
  PaginatedListOfComponentTemplateDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../../component-templates-library/ComponentTemplateLibrary";

// Use to delete component template from the sidebar
export const useCreateComponentTemplateMutation = (
  componentType: ComponentType,
) => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    queryKey: [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY, { componentType }],
    successToastMessage: "Template created.",
    mutationFn: ComponentsService.createComponentTemplate,
    optimisticUpdater: {
      updateFn: (
        oldData: InfiniteData<PaginatedListOfComponentTemplateDto>,
        newData: IAddComponentTemplateCommand,
        tempId: number,
      ) => {
        return INFINITE_PAGINATED_DATA_UPDATERS.addItem(
          oldData,
          new ComponentTemplateDto({
            ...newData,
            type: componentType,
            private: true,
            id: String(tempId),
          }),
        ) as InfiniteData<PaginatedListOfComponentTemplateDto>;
      },
    },
    invalidateQueryOptions: {
      enabled: true,
    },
    exactQueryKey: false,
    successUpdater: {
      updateFn: (oldData, id, tempId) =>
        INFINITE_PAGINATED_DATA_UPDATERS.updateItemProperties(oldData, tempId, {
          id: String("CUSTOM_ASSET_OWNERSHIP:" + id),
        }) as InfiniteData<PaginatedListOfComponentTemplateDto>,
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [COMPONENT_TEMPLATES_LIST_QUERY_KEY],
          exact: false,
          refetchType: "none",
        });
      },
    },
  });
};
